export interface Property {
    id: string;
    label: string;
    field: string;
    fieldAggr?: string;
    width?: number;
    unit?: string;
    context?: string;
}

export enum PropertyDataContext {
    CULTIVAR = 'CULTIVAR',
    SAMPLE = 'SAMPLE',
    EVALUATION = 'EVALUATION',
    SITE = 'SITE',
    MISCELLANEOUS = 'MISCELLANEOUS',
}